import { isRejectedWithValue } from "@reduxjs/toolkit";
import { recordError } from "../../instrumentation";

export const apiErrorLogger = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const endpointName = action.meta?.arg?.endpointName ?? "unknown";
    const status = action.payload?.status ?? "unknown";
    const errorData = action.payload?.data ?? action.payload?.error ?? action.payload;

    recordError(new Error(`API error: ${endpointName}`), {
      "api.endpoint": endpointName,
      "api.status": String(status),
      "api.error": typeof errorData === "string" ? errorData : JSON.stringify(errorData),
    });
  }
  return next(action);
};
